import { useNavigate } from "react-router-dom";
import React from "react";
function UserPolicy() {
  const navigate = useNavigate();
  const handleLinkPage = () => {
    navigate(`/`);
  };
  return (
    <div className="bg-background-app w-full grid grid-cols-12  h-auto font-noto-sans-thai">
      <div className="col-span-10 md:col-span-8 col-start-2 md:col-start-3 w-full h-auto my-10 md:my-20 ">
        <div className="bg-primary-contrast rounded-[40px] h-[calc(100vh_-_7rem)] shadow-z16 p-4 lg:p-8 flex flex-col gap-12">
          <div className="flex flex-col gap-1">
            <button
              className="bg-primary-main w-6 h-6 self-end rounded-full"
              onClick={handleLinkPage}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7782 7.22943C16.4824 6.93364 16.0045 6.93364 15.7088 7.22943L12 10.9306L8.29124 7.22184C7.99545 6.92605 7.51763 6.92605 7.22184 7.22184C6.92605 7.51763 6.92605 7.99545 7.22184 8.29124L10.9306 12L7.22184 15.7088C6.92605 16.0045 6.92605 16.4824 7.22184 16.7782C7.51763 17.0739 7.99545 17.0739 8.29124 16.7782L12 13.0694L15.7088 16.7782C16.0045 17.0739 16.4824 17.0739 16.7782 16.7782C17.0739 16.4824 17.0739 16.0045 16.7782 15.7088L13.0694 12L16.7782 8.29124C17.0664 8.00303 17.0664 7.51763 16.7782 7.22943Z"
                  fill="white"
                />
              </svg>
            </button>
            <p className="self-center text-xl font-bold text-text-primary">
              นโยบายความเป็นส่วนตัว
            </p>
          </div>
          <div className="flex flex-col gap-4 overflow-y-auto">
            <div className="flex flex-col gap-4">
              <p className="text-text-primary text-base font-semibold">
                {`สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)`}
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                ต่อไปนี้เรียกว่า “สำนักงานฯ” ขอแจ้งข้อตกลง
                และเงื่อนไขการให้บริการ ระบบแจ้งเตือนจุดเกิดความร้อน
                ต่อไปนี้จะเรียกว่า “ระบบ”
                ให้เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                สำนักงานฯ
                เป็นผู้ให้บริการข้อมูลจากดาวเทียมด้านการประยุกต์ทางการติดตามภัยพิบัติ
                และทางด้านการเกษตร โดยผ่านเว็บไซต์และโมบายแอปพลิเคชัน สำนักงานฯ
                เล็งเห็นความสำคัญสูงสุดกับความเป็นส่วนตัว
                ความปลอดภัยของข้อมูลส่วนบุคคล
                การรักษาข้อมูลส่วนบุคคลของผู้ใช้บริการไว้เป็นความลับ
                รวมถึงการปกป้องข้อมูลเหล่านั้นจากการใช้ในทางที่ผิด
                ดังนั้นเพื่อประโยชน์ของผู้ใช้บริการ
                และความปลอดภัยจากการได้รับสิทธิ์คุ้มครองตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                พ.ศ. 2562 สำนักงานฯ ขอแจ้ง ข้อตกลง และเงื่อนไขการให้บริการ
                ตลอดจนขอชี้แจงรายละเอียดเกี่ยวกับนโยบายความเป็นส่วนตัวว่า
                สำนักงานฯ มีการเก็บรวบรวมข้อมูลส่วนบุคคลอย่างไร
                ข้อมูลใดบ้างที่มีการเก็บรวบรวม
                วัตถุประสงค์ในการเก็บรวบรวมการใช้และการเปิดเผยข้อมูลของผู้ใช้บริการให้เป็นไปตามกฎหมาย
                รวมถึงช่องทางการติดต่อขอลบหรือเปลี่ยนแปลงข้อมูลส่วนบุคคลด้วย
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                นโยบายความเป็นส่วนตัวฉบับนี้จะมีผลบังคับใช้กับผู้ใช้บริการทุกท่าน
                กรุณาอ่านนโยบายความเป็นส่วนตัวนี้อย่างรอบคอบเพื่อให้ท่านเข้าใจถึงหลักการและวิธีการใช้ข้อมูลดังกล่าว
              </p>
              <p className="text-text-primary text-base font-semibold ">
                เก็บรวบรวม
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                สำนักงานฯ
                ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลที่อาจจะสามารถระบุตัวตนของบุคคลได้ทั้งทางตรงและทางอ้อม
                โดยจะเก็บรวบรวมเฉพาะข้อมูลที่จะนำไปประมวลผลเพื่อการวิเคราะห์
                วางแผนบริหารจัดการข้อมูลจากดาวเทียม ในภารกิจส่งเสริม
                ป้องกันและบริหารจัดการภัยพิบัติโดยเฉพาะอย่างยิ่งไฟป่า
                โดยให้เป็นประโยชน์ต่อผู้ใช้บริการเท่านั้น
                ซึ่งมีการแยกประเภทข้อมูล และวัตถุประสงค์ในการเก็บรวบรวมไว้
                ดังนี้
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                1. ชื่อ - นามสกุล เป็นการระบุตัวตนของผู้ใช้บริการ
                เพื่อทำให้ง่ายต่อการจัดเก็บรวบรวมบัญชีผู้ใช้งาน
                และเพื่อความสะดวกในการนำไปส่งเสริมการวิเคราะห์
                ประมวลผลข้อมูลภาพดาวเทียม
                และเพื่อประโยชน์ต่อผู้ใช้บริการในภารกิจส่งเสริม
                ป้องกันและบริหารจัดการภัยพิบัติ
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                2. หมายเลขโทรศัพท์ เพื่อใช้การ การระบุตัวตนแบบหนึ่งสำหรับโมบาย
                แอพพลิเคชั่น และนอกจากนั้น
                หมายเลขโทรศัพท์เป็นช่องทางในการติดต่อผู้ใช้บริการ
                ในกรณีที่สำนักงานฯ ต้องการแจ้งข่าวสารที่เกี่ยวข้องกับสำนักงานฯ
                และเนื้อหาที่เกี่ยวข้องกับการจัดการภัยพิบัติโดยเฉพาะอย่างยิ่งไฟป่า
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                3. ที่อยู่ เพื่อเป็นข้อมูลพื้นที่ฐานของผู้ใช้บริการ
                และยังนำมาการวิเคราะห์สถิติการใช้งานรายพื้นที่
                ร่วมกับข้อมูลตำแหน่งของการเกิดไฟป่า การเข้าไปทำ ภารกิจ ดับไฟป่า
                และเพื่อประโยชน์ในการภารกิจส่งเสริม
                ป้องกันและบริหารจัดการภัยพิบัติต่อไป
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                4. อีเมล
                เพื่อใช้เป็นการระบุตัวตนของผู้ใช้บริการและเป็นช่องทางสำหรับการสมัครเข้าใช้บริการระบบทั้งเว็บ
                แอปพลิเคชันและโมบาย
                แอปพลิเคชันอกจากนั้นอีเมลจะเป็นช่องทางในการติดต่อผู้ใช้บริการ
                ในกรณีที่สำนักงานฯต้องการแจ้งข่าวสารที่เกี่ยวข้องกับสำนักงานฯ
                และเนื้อหาที่เกี่ยวข้องกับการจัดการภัยพิบัติโดยเฉพาะอย่างยิ่งไฟป่า
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                5. รหัสผ่าน เพื่อยืนยันและระบุตัวตนก่อนเข้าสู่ระบบ
                เป็นการป้องกันการถูกแอบอ้าง
                และความปลอดภัยในการเข้าถึงข้อมูลส่วนบุคคล โดยสำนักงานฯ
                จะเก็บข้อมูลรหัสผ่านในรูปแบบการเข้ารหัสตามมาตรฐานการจัดเก็บรหัสผู้ใช้งาน
                เพื่อความปลอดภัยของบัญชีผู้ใช้งาน
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                6. ตำแหน่งของการเข้าไปทำภารกิจ
                เพื่อใช้ในการวิเคราะห์ข้อมูลความสามารถในการเข้าไปทำภารกิจดับไฟป่า
                ในพื้นที่ที่รับผิดชอบ
                และนำมาแสดงผลในภาพรวมการปฏิบัติงานในระดับพื้นที่
                และเพื่อให้สำนักงานฯ ในการภารกิจส่งเสริม
                ป้องกันและบริหารจัดการภัยพิบัติอื่นๆ ต่อไป
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                7. ภาพถ่าย ภาพเคลื่อนไหว จากการเข้าไปปฏิบัติภารกิจ
                พร้อมตำแหน่งของภาพ เพื่อใช้ในการแสดงข้อมูล และการวิเคราะห์ข้อมูล
                ผลการปฏิบัติงานขณะทำภารกิจดับไฟป่าในพื้นที่ที่รับผิดชอบ
                และนำมาแสดงผลในรายตำแหน่งเกิดไฟป่า
                และแสดงผลในภาพรวมการปฏิบัติงานในระดับพื้นที่
                และเพื่อให้สำนักงานฯ
                ในการวิเคราะห์สอบเทียบกับภาพดาวเทียมให้มีความแม่นยำมากขึ้น
                และรวมไปถึงภารกิจส่งเสริม
                ป้องกันและบริหารจัดการภัยพิบัติอื่นๆต่อไป
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                8. ประวัติการเข้ามาใช้งานระบบ
                สำนักงานฯจะเก็บข้อมูลประวัติการเข้ามาใช้งานระบบ
                เพื่อนำข้อมูลต่างๆที่เกิดขึ้นจากการใช้งานนำมาปรับปรุงระบบ
                ให้ผู้ใช้บริการได้รับประสบการณ์การใช้งานที่ดีขึ้น
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                ทั้งนี้ เพื่อประโยชน์ในการใช้ข้อมูลส่วนบุคคลตามที่กล่าวไว้
                สำนักงานฯจะไม่จัดเก็บข้อมูลส่วนบุคคลอื่น ๆ ของท่าน เว้นแต่
              </p>
              <ul className="indent-8 text-text-primary text-base font-medium grid grid-cols-1 gap-2">
                <li>- ได้รับความยินยอมโดยชัดแจ้งจากเจ้าของข้อมูล</li>
                <li>
                  - เป็นไปเพื่อประโยชน์ต่อการวิเคราะห์ข้อมูลภาพดาวเทียม
                  และภารกิจส่งเสริม ป้องกันและบริหารจัดการภัยพิบัติของประเทศ และ
                  ภารกิจอื่นๆของสำนักงานฯ
                </li>
                <li>
                  - เพื่อประโยชน์ในการศึกษา วิจัย หรือการจัดทำสถิติที่เกี่ยวข้อง
                </li>
              </ul>
              <p className="text-text-primary text-base font-medium indent-8 ">
                ในส่วนของระยะเวลาการจัดเก็บข้อมูลส่วนบุคคลเหล่านี้นั้น
                สำนักงานฯจะจัดเก็บข้อมูลส่วนบุคคลทั้งหมดที่ผู้ใช้บริการให้ไว้ตลอดระยะเวลาที่ยังคงเป็นผู้ใช้บริการของระบบ
                และหลังจากวันที่ผู้ใช้บริการลบบัญชีผู้ใช้งานออกจากระบบอย่างน้อย
                90 วัน อันเนื่องมาจากข้อบังคับทางกฎหมาย
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                ข้อมูลส่วนบุคคลที่ผู้ใช้บริการได้ให้ไว้ในระบบทั้งหมด
                ผู้ใช้บริการสามารถเข้ามาเปลี่ยนแปลง หรือแก้ไขได้ตลอดเวลา
                ผ่านช่องทางในระบบที่มีให้
              </p>
              <p className="text-text-primary text-base font-semibold ">
                การนำข้อมูลส่วนบุคคลไปใช้
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                เมื่อสำนักงานฯ
                ได้รับการยินยอมให้เก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการแล้ว
                สำนักงานฯ จะนำข้อมูลส่วนบุคคลมาใช้ในรูปแบบต่าง ๆ เช่น วิเคราะห์
                ประมวลผล ตลอดจนแสดงผลแก่ผู้ใช้บริการ และใช้ภายในสำนักงานฯ
                ตามรายละเอียดดังนี้
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                1.
                ใช้จัดทำและพัฒนาระบบเพื่อระบบทั้งเว็บแอพพลิเคชั่นและโมบายแอปพลิเคชันนี้
                และระบบอื่นๆของสำนักงานฯ ต่อไป
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                2. ใช้เพื่อปฏิบัติตามขั้นตอนการสร้างบัญชีผู้ใช้งานให้แล้วเสร็จ
                และให้สามารถทำงานได้ตรงตามที่ระบบกำหนดไว้อย่างเป็นลำดับ
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                3. ใช้ในการมอบหมายภารกิจดับไฟป่า ให้แก่ผู้ใช้งาน
                โดยให้ผู้ใช้งานนำเข้าข้อมูลที่จำเป็นเกี่ยวกับพื้นที่ที่คาดว่าจะเกิดไฟป่า
                รายงานข้อมูลเข้าสู่ระบบ
                และใช้สำหรับรายงานสถานการณ์ทำงานให้ผู้ใช้งานทราบ
                และรายงานภาพรวมรายพื้นที่ตามรับผิดชอบ
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                4. ใช้สำหรับเชื่อมต่อสื่อสาร ค้นหาข้อมูลจะระบบอื่นๆ ในสำนักงานฯ
                และนำมาแสดงผลในระบบให้แก่ผู้ใช้บริการ เช่น
                ข้อมูลจากระบบภัยพิบัติ ข้อมูลจากระบบพืชเศรษฐกิจ
                ข้อมูลจากระบบบริการข้อมูล และระบบอื่นๆในอนาคต เป็นต้น
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                5. ใช้เป็นช่องทางการยืนยันตัวตน และยืนยันเพื่อเข้าสู่ระบบ
                ซึ่งอาจจะรวมไปถึงระบบอื่นๆ ที่เกิดขึ้นใน สำนักงานฯ
                โดยไม่ต้องร้องขอข้อมูลผู้ใช้งาน
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                6. ใช้เป็นช่องทางประชาสัมพันธ์ ข่าวสารต่าง ๆ
                ตลอดจนติดต่อสอบถามและแนะนำข้อมูลเพิ่มเติมเกี่ยวกับการให้บริการ
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                7. ใช้เป็นช่องทางการติดต่อกรณีฉุกเฉิน
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                8. นำไปจัดทำสถิติที่ไม่ระบุตัวตน เพื่อภารกิจของสำนักงานฯ
                และการปรับปรุง พัฒนาการให้บริการ
              </p>
              <p className="text-text-primary text-base font-medium indent-8 ">
                {`9. ใช้เพื่อการจัดการทั่วไปอันเกี่ยวข้องกับการใช้งานต่างๆข้างต้น การเผยแพร่ข้อมูลส่วนบุคคลข้อมูลส่วนบุคคลที่มีการเก็บรวบรวมผ่านระบบ`}
              </p>

              <p className="text-text-primary text-base font-medium indent-8">
                สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                สำนักงานใหญ่ (ศูนย์ราชการเฉลิมพระเกียรติ 80 พรรษา 5 ธันวาคม
                2550) เลขที่ 120 อาคารรวมหน่วยราชการ (อาคารรัฐประศาสนภักดี) ชั้น
                6 และชั้น 7 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ
                10210 Call Center 0 2141 4444,0 2141 4674 โทรสาร 0-2143-9586
                อีเมล INFO@GISTDA.OR.TH
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPolicy;
